<template>
  <nav class="menu-top-logo menu-fixed interno" data-menu-anima="fade-in">
    <div class="container">
      <div class="menu-brand">
        <router-link to="/">
          <img class="logo-default scroll-hide"
               :src="require('Assets/images/logo.png')" alt="logo"
          />
          <img class="logo-retina scroll-hide" :src="require('Assets/images/logo.png')" alt="logo"/>
          <img class="logo-default scroll-show"
               :src="require('Assets/images/logo.png')" alt="logo"
          />
          <img class="logo-retina scroll-show" :src="require('Assets/images/logo.png')" alt="logo"/>
        </router-link>
      </div>
      <i class="menu-btn"></i>
      <div class="menu-cnt">
        <ul id="main-menu">
          <li class="">
            <router-link to="/">Home</router-link>

          </li>
          <li class="">
            <router-link to="/sobre">Sobre</router-link>
          </li>
          <li class="dropdown">
            <a href="#">Produtos</a>
            <ul>
              <li class="dropdown-submenu">
                <a>Módulos</a>
                <ul>
                  <li>
                    <router-link to="/produtos/amerisolar">Amerisolar</router-link>
                  </li>
                  <li>
                    <router-link to="/produtos/dahsolar">Dah Solar</router-link>
                  </li>
                  <li>
                    <router-link to="/produtos/seraphim">Seraphim</router-link>
                  </li>
                </ul>
              </li>
              <li class="dropdown-submenu">
                <a>Inversores</a>
                <ul>
                  <li>
                    <router-link to="/produtos/chint">Chint</router-link>
                  </li>
                  <li>
                    <router-link to="/produtos/growatt">Growatt</router-link>
                  </li>
                  <li>
                    <router-link to="/produtos/saj">SAJ</router-link>
                  </li>
                  <li>
                    <router-link to="/produtos/canadian">Canadian</router-link>
                  </li>
                </ul>
              </li>
              <li class="dropdown-submenu">
                <a>Estruturas</a>
                <ul>
                  <li>
                    <router-link to="/produtos/romagnole">Romagnole</router-link>
                  </li>
                  <li>
                    <router-link to="/produtos/alumax">Alumax</router-link>
                  </li>
                </ul>
              </li>
              <li class="dropdown-submenu">
                <a>String Box</a>
                <ul>
                  <li>
                    <router-link to="/produtos/clamper">Clamper</router-link>
                  </li>
                </ul>
              </li>

              <li class="dropdown-submenu">
                <a>Transformadores</a>
                <ul>
                  <li>
                    <router-link to="/produtos/wise">Wise</router-link>
                  </li>
                </ul>
              </li>
              <li class="dropdown-submenu">
                <a>Conectores MC4</a>
                <ul>
                  <li>
                    <router-link to="/produtos/staubli">Staubli</router-link>
                  </li>
                </ul>
              </li>
              <li class="dropdown-submenu">
                <a>Cabos</a>
                <ul>
                  <li>
                    <router-link to="/produtos/sil">Sil</router-link>
                  </li>
                </ul>
              </li>
            </ul>
          </li>
          <li>
            <a href="https://piedskysolar.skygroupbr.com">Cadastro</a>
          </li>
          <li class="">
            <router-link to="/contato">Contato</router-link>
          </li>


          <li class="nav-label">
            <a href="https://api.whatsapp.com/send?phone=554430520044&text=Ol%C3%A1!%20">
              <i class="fab fa-whatsapp"></i> <span>WHATSAPP (CLIQUE AQUI)</span> (44) 3052-0044
            </a>
          </li>
        </ul>

        <div class="menu-right">
          <a href="https://piedskysolar.skygroupbr.com" class="btn btn-border btn-xs">
            PORTAL DO CLIENTE&nbsp;&nbsp; &nbsp; &nbsp;
          </a>
        </div>
      </div>
    </div>
  </nav>
</template>

<script>
export default {
  name: 'HeaderInterno',
};
</script>

<style scoped>
nav {
  margin-top: 0 !important;
}
</style>
